var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-component',{attrs:{"loading":false,"models":_vm.models,"usar_filtros":false,"model_name":"article_purchase","set_model_on_click":false,"show_actualizado":false,"show_btn_edit":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }